module.exports = __webpack_public_path__ + "static/media/PC90H_ good.7a872c6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/options/PC90H_ good.jpg
// module id = 216
// module chunks = 0